import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/logo/gt-text-beautyagent.svg';

var _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("i", {
  class: "icon-envelope"
}, null, -1);

var _hoisted_3 = {
  class: "unread-num-wrap"
};
var _hoisted_4 = {
  class: "unread-num"
};
var _hoisted_5 = {
  class: "main-swiper"
};
var _hoisted_6 = {
  class: "page-content-inner pt-20px"
};
var _hoisted_7 = {
  class: "page-inner"
};
var _hoisted_8 = {
  class: "left-dash-title sty-2side"
};
var _hoisted_9 = {
  class: "title-txt"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" MORE ");

var _hoisted_11 = {
  class: "card-main"
};
var _hoisted_12 = {
  class: "card-title"
};
var _hoisted_13 = {
  class: "card-info-bar"
};

var _hoisted_14 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-clock-o",
  "aria-hidden": "true"
}, null, -1);

var _hoisted_15 = {
  class: "bar-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_f7_nav_left = _resolveComponent("f7-nav-left");

  var _component_f7_nav_title = _resolveComponent("f7-nav-title");

  var _component_f7_link = _resolveComponent("f7-link");

  var _component_f7_nav_right = _resolveComponent("f7-nav-right");

  var _component_f7_navbar = _resolveComponent("f7-navbar");

  var _component_f7_swiper_slide = _resolveComponent("f7-swiper-slide");

  var _component_f7_swiper = _resolveComponent("f7-swiper");

  var _component_f7_icon = _resolveComponent("f7-icon");

  var _component_f7_col = _resolveComponent("f7-col");

  var _component_f7_row = _resolveComponent("f7-row");

  var _component_f7_page = _resolveComponent("f7-page");

  return _openBlock(), _createBlock(_component_f7_page, {
    name: "index",
    class: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_f7_navbar, {
        ref: "nav",
        class: "sty-index"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_nav_left, null, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          }), _createVNode(_component_f7_nav_title), _createVNode(_component_f7_nav_right, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_link, {
                class: ["icon-badge-wrap", {
                  'is-unread-overflow': $setup.unread > 99
                }],
                "data-num": $setup.unread,
                href: "/notification_list/id/0/name/0/page/1"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2, _createVNode("div", _hoisted_3, [_createVNode("span", _hoisted_4, _toDisplayString($setup.unread > 99 ? '99+' : $setup.unread), 1)])];
                }),
                _: 1
              }, 8, ["class", "data-num"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 512), _createVNode("div", _hoisted_5, [_createVNode(_component_f7_swiper, {
        pagination: "",
        autoplay: {
          delay: 8000
        }
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.banner, function (item) {
            return _openBlock(), _createBlock(_component_f7_swiper_slide, {
              key: item.id
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_f7_link, {
                  class: "swiper-item external",
                  style: {
                    'background-image': "url(".concat(item.src, ")")
                  },
                  onClick: function onClick($event) {
                    return $setup.m_open_window(item.link);
                  }
                }, null, 8, ["style", "onClick"])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })]), _createVNode("div", _hoisted_6, [_createVNode("div", _hoisted_7, [(_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.textEditor, function (block) {
        return _openBlock(), _createBlock("div", {
          class: "section-block",
          key: block.id
        }, [_createVNode("h4", _hoisted_8, [_createVNode("div", _hoisted_9, _toDisplayString(block.name), 1), _createVNode(_component_f7_link, {
          class: "tiny-more-btn",
          href: "/news_list/category/".concat(block.id)
        }, {
          default: _withCtx(function () {
            return [_hoisted_10, _createVNode(_component_f7_icon, {
              f7: "chevron_right"
            })];
          }),
          _: 2
        }, 1032, ["href"])]), _createVNode(_component_f7_row, null, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(block.list, function (item) {
              return _withDirectives((_openBlock(), _createBlock(_component_f7_col, {
                width: "50",
                key: item.id
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    class: "info-card",
                    href: "/news_detailed/id/".concat(item.id, "/category/").concat(block.id)
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode("div", {
                        class: "card-media",
                        style: "background-image:url(".concat(item.src ? item.src : '/src/assets/images/preset/default.png', ")")
                      }, null, 4), _createVNode("div", _hoisted_11, [_createVNode("div", _hoisted_12, _toDisplayString(item.title), 1), _createVNode("div", _hoisted_13, [_hoisted_14, _createVNode("div", _hoisted_15, _toDisplayString($setup.dateDisplay(item.date)), 1)])])];
                    }),
                    _: 2
                  }, 1032, ["href"])];
                }),
                _: 2
              }, 1536)), [[_vShow, block.list.length]]);
            }), 128))];
          }),
          _: 2
        }, 1024)]);
      }), 128))])])];
    }),
    _: 1
  });
}